import { AutoFormSection } from "models/autoForm";
import { UseFormReturn } from "react-hook-form";
import useAutoSave from "components/FormElements/useAutoSave";
import { useMemo } from "react";
import { FloatingFieldSize } from "design-system/components/FloatingField/context";
import { buildDataTransformer } from "./buildForm";
import DynamicForm from "./DynamicForm";

interface AutoSaveFormProps {
  form: UseFormReturn<any>;
  sections: AutoFormSection[];
  submitUrl: string;
  isLoaded?: boolean;
  onSuccess?: (res: any, payload: any) => void;
  size?: FloatingFieldSize;
}

export default function AutoSaveForm({
  form,
  sections,
  submitUrl,
  isLoaded = true,
  onSuccess = () => {},
  size,
}: AutoSaveFormProps) {
  const transformData = useMemo(() => buildDataTransformer(sections), [sections]);
  useAutoSave({ form, transformData, submitUrl, onSuccess });

  return <DynamicForm form={form} sections={sections} isLoaded={isLoaded} size={size} />;
}
